<div class="captain-panel-container" (click)="unlockAudioOnce()" (touchstart)="unlockAudioOnce()">
  <!-- Mobil üst bar: menü, başlık, bildirim sayısı -->
  <header class="mobile-header">
    <button type="button" class="mobile-menu-btn" (click)="toggleMobileMenu()" aria-label="Menü">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12h18M3 6h18M3 18h18"/></svg>
    </button>
    <h1 class="mobile-title">{{ currentView === 'requests' ? 'Talepler' : 'Geçmiş' }}</h1>
    <div class="mobile-badge-wrap">
      <span class="mobile-badge" *ngIf="currentView === 'requests' && waitingRequests.length > 0">{{ waitingRequests.length }}</span>
      <span class="mobile-badge-placeholder" *ngIf="currentView !== 'requests' || waitingRequests.length === 0"></span>
    </div>
  </header>

  <!-- Mobil sidebar overlay -->
  <div class="sidebar-overlay" [class.open]="mobileMenuOpen" (click)="closeMobileMenu()" aria-hidden="true"></div>

  <div class="sidebar-wrap" [class.drawer-open]="mobileMenuOpen">
    <app-sidebar [systemStatus]="systemStatus" [waitingCount]="waitingRequests.length" [currentView]="currentView"
      (systemStatusChange)="onSystemStatusChange($event)" (navigateToRequests)="navigateToRequests()"
      (navigateToHistory)="navigateToHistory()"></app-sidebar>
  </div>

  <div class="main-content" [class.history-view]="currentView === 'history'"
    [class.mobile-detail-view]="currentView === 'requests' && selectedRequest">
    <!-- Mobil: detay ekranında "Listeye dön" çubuğu -->
    <div class="mobile-back-bar" [class.visible]="currentView === 'requests' && selectedRequest">
      <button type="button" class="mobile-back-btn" (click)="onBackFromDetail()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        <span>Listeye dön</span>
      </button>
    </div>
    <!-- Loading indicator -->
    <div *ngIf="(currentView === 'requests' && isLoadingRequests) || (currentView === 'history' && isLoadingHistory)"
      class="loading-overlay">
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>Yükleniyor...</p>
      </div>
    </div>

    <!-- Content -->
    <ng-container
      *ngIf="!(currentView === 'requests' && isLoadingRequests) && !(currentView === 'history' && isLoadingHistory)">
      <app-request-list [requests]="currentView === 'history' ? historyRequests : waitingRequests"
        [selectedRequest]="selectedRequest" [showHistory]="currentView === 'history'"
        [autoResponseThresholdMinutes]="requestTimeoutMinutes"
        (selectRequest)="selectRequest($event)" (refresh)="loadWaitingRequests()"></app-request-list>

      <!-- Mobilde sadece talep seçiliyken detay göster; masaüstünde her zaman (Bir talep seçin dahil) -->
      <app-request-detail *ngIf="currentView === 'requests' && (selectedRequest || !isMobileView)" [request]="selectedRequest"
        [isSystemOpen]="isSystemOpen" [isSystemBusy]="systemStatus === 'busy'"
        [isLoading]="isProcessingResponse" (quickResponse)="onQuickResponse($event)"></app-request-detail>
    </ng-container>
  </div>
</div>

<app-dialog *ngIf="showDialog" [config]="dialogConfig" (close)="onDialogClose()" (confirm)="onDialogClose()">
</app-dialog>